<template>
    <div class="container-fluid" >
        <div class="row justify-content-between">
            <div class="col"><h3>Багш</h3></div>
             <div class="col-auto" v-if="userProfile.role=='superadmin' || userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager'">
                <router-link to="/teacheradd/new">
                    <div class="btn btn-danger">Багш нэмэх</div>
                </router-link>
                <!-- <router-link to="/teachersadd">
                    <div class='btn btn-danger ml-2'>Багш нарын мэдээлэл бөөнөөр нэмэх</div>
                </router-link> -->
            </div>  
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="row">
                    <div class="col">
                        <h6 class="m-0 font-weight-bold text-primary">Багш нарын жагсаалт</h6>
                    </div>
                    <div class="col-auto">
                        <i class="fas fa-grip-horizontal text-danger" style="font-size:20px;" v-if="showSimple" @click="showSimple=!showSimple"></i>
                        <i class="fas fa-grip-lines text-danger" style="font-size:20px;" v-else @click="showSimple=!showSimple"></i>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 my-3">
                        <div class="btn-group" role="group" >
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='email'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='email' }">Имэйл</button>
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='code'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='code' }">Код</button>
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='name'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='name' }">Нэр</button>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group" >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Та хайх талбараа сонгоод хайх утгаа оруулаад хайх товч дээр дарна уу"
                                v-model="searchValue"
                                v-on:keyup.enter="search(searchValue)"
                            />
                        </div>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success btn-block" @click="search(searchValue)"><i class="mr-2 fas fa-search"></i>Хайх</button>
                    </div>
                </div>
                <div class="mb-3" v-if="searched && searchValue!=null && searchValue!=''">
                    <h4>
                        <div class="badge badge-pill badge-info">
                            {{searchValue}}
                            <i @click="searchValue=null;searched=false;_getData()" class="fas fa-times ml-2" style="cursor:pointer"></i>
                        </div>
                    </h4>
                </div>
                <div class="table-responsive" v-if="teachers!=null && teachers.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Овог/Нэр</th>
                        <th>Багшийн код</th>
                        <th v-if="!showSimple">Сургууль</th>
                        <th v-else>Хөтөлбөр</th>
                        <th v-if="!showSimple">Тэнхим</th>
                        <th v-if="!showSimple">Хөтөлбөр</th>
                        <th>имэйл</th>
                        <th v-if="!showSimple">төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in teachers" v-bind:key="teacher.id">
                            <td>{{index+1}}</td>
                            <td>{{teacher.lastname}} / {{teacher.name}}</td>

                            <td>{{teacher.code}}</td>
                            <td v-if="!showSimple">
                                <div >
                                    <span v-if="teacher.school!=null">{{teacher.school.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                            </td>
                            <td v-else>
                                <div >
                                    <span v-if="teacher.school!=null">{{teacher.school.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                                <div >
                                    <span v-if="teacher.department!=null">{{teacher.department.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                                <div >
                                    <span v-if="teacher.program!=null">{{teacher.program.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                            </td>
                            <td v-if="!showSimple">
                                <div >
                                    <span v-if="teacher.department!=null">{{teacher.department.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                            </td>
                            <td v-if="!showSimple">
                                <div >
                                    <span v-if="teacher.program!=null">{{teacher.program.id}}</span>
                                    <span v-else style="color:red">Сонгоогүй</span>
                                </div>
                            </td>
                            <td>{{teacher.email}}</td>
                            <td v-if="!showSimple">
                                <span v-if="teacher.googleUser==null || teacher.googleUser==undefined" class="badge badge-danger">Системд холбогдоогүй</span>
                                <span v-else class="badge badge-success">Системд холбогдсон</span>
                            </td>
                            <td>
                                <button class="btn btn-success btn-sm" @click="$router.push({ name:'TeacherDetail', params:{ studentId: teacher.id} })">харах</button>
                                <button v-if="userProfile.role=='superadmin' || userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager'" class="btn btn-warning btn-sm ml-2" @click="_edit(teacher)">засах</button>
                                <button  class="btn btn-danger btn-sm ml-2" @click="deleteUser(teacher, index)" v-if="(teacher.googleUser==null || teacher.googleUser==undefined) && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">устгах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getTeacherData()" class="btn btn-primary btn-block">Дараагийнх</button>
                        <button v-else type="button" class="btn btn-success btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор багшийн мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:20,
               schools:null
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            async _getData(){

                this.teachers=[];
                await this.readSchool();
                this.getTeacherData();
            },
            async readSchool(){
                // console.log(this.userProfile['role']);
                if(this.userProfile!=null && this.userProfile['role']!=null && (this.userProfile['role']=="admin"  || this.userProfile['role']=="superadmin")){
                    // console.log("admin_________")
                }
                else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null){
                    var cusDoc=await this.userProfile['customer'].get();
                    if(cusDoc.exists)
                        this.schools=cusDoc.data().schools;
                }
            },
            async getTeacherData(){

                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("teachers").orderBy("createdAt", "desc");
                    
                    else
                        query=fb.db.collection("teachers").orderBy("createdAt", "desc").startAfter(this.lastVisible);

                    if(this.schools && this.schools.length>0){
                        query=query.where('school', "in", this.schools)
                    }
                    
                    query=query.limit(25);
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data()
                            object.id = doc.id;
                            this.teachers.push(object);
                        });
                        if(documentSnapshots.size!=25)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            },
            _edit(teacher){
                this.$router.push({ name: 'TeacherAdd', params: { teacherId: teacher.id} })
            },
            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.teachers=[];
                    this.searchBy(value);
                }
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("teachers").where(this.searchField, "==", value);
                    if(this.schools!=null){
                        query=query.where('school', "in", this.schools)
                    }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },
            deleteUser(user, index){
                var r = confirm("Та "+user.name+ " устгахдаа итгэлтэй байна уу!!!");
                if (r == true) {
                    fb.db.collection("teachers").doc(user.id).delete();
                    this.teachers.splice(index, 1);
                }
            }

  
        },
        created() {
            this.teachers=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
